var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error.visible)?_c('div',{staticClass:"snackbar show danger"},[_c('p',[_vm._v(_vm._s(_vm.error.message))]),_c('button',{on:{"click":_vm.hideError}},[_vm._v("X")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }